import { useMutation, useQuery } from '@tanstack/react-query';
import { getTechnicianServiceAreas, putTechnicianServiceAreas } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonDataItem } from 'types';

export const useTechnicianServiceArea = (technicianId?: string) => {
  const {
    data: serviceArea,
    isLoading: isServiceAreaLoading,
    refetch: refetchServiceArea,
  } = useQuery(['technician-service-areas', { technicianId }], getTechnicianServiceAreas, {
    enabled: !!technicianId,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const { mutate: saveServiceArea, isLoading: isServiceAreaSaving } = useMutation(putTechnicianServiceAreas, {
    onSuccess: () => {
      Toast.show({ description: 'The Service Area has been successfully updated', type: Toast.Type.Success });
      refetchServiceArea();
    },
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  return {
    suburbs: serviceArea?.suburbs,
    home: serviceArea?.home,
    isServiceAreaLoading,
    saveServiceArea,
    isServiceAreaSaving,
  };
};
